import { useTranslations } from "next-intl";
import { css, cx } from "styled-system/css";

import { Tag, type TagVariant } from "@/components/tag";

import { CATEGORY_TRANSLATION_KEYS, STATUS_TRANSLATION_KEYS } from "../../category-keys";
import type { RewardCategory, RewardStatus } from "../../types";

interface RewardCardTagsProps {
  category: RewardCategory;
  status: RewardStatus;
}

export function RewardCardTags({ category, status }: RewardCardTagsProps) {
  const tCategory = useTranslations("rewards.category");
  const tStatus = useTranslations("rewards.status");

  return (
    <div className={containerStyles}>
      <Tag
        variant={categoryVariant(status)}
        className={cx(tagLetterStyles, status !== "claimable" && nonClaimableCategoryOverride)}
      >
        {tCategory(CATEGORY_TRANSLATION_KEYS[category])}
      </Tag>
      <Tag variant={statusVariant(status)} className={tagLetterStyles}>
        {tStatus(STATUS_TRANSLATION_KEYS[status])}
      </Tag>
    </div>
  );
}

const containerStyles = css({
  display: "flex",
  gap: "4",
  alignItems: "center",
  justifyContent: "space-between",
});

const tagLetterStyles = css({ letterSpacing: "[1px]", whiteSpace: "nowrap" });

const nonClaimableCategoryOverride = css({
  bg: "background.tertiary!",
  color: "text.secondary!",
});

function categoryVariant(status: RewardStatus): TagVariant {
  return status === "claimable" ? "positive" : "secondary";
}

function statusVariant(status: RewardStatus): TagVariant {
  switch (status) {
    case "claimable":
      return "positive";
    case "in_progress":
      return "gold";
    case "claimed":
      return "secondary";
    case "not_eligible":
    case "expired":
      return "negative";
  }
}
